import React, { useState } from "react";
import { FaLink } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

import Divider from "../../../../../ui/Divider";

interface TreatmentLink {
  url: string;
  title: string;
}

interface WantToKnowMoreProps {
  links: TreatmentLink[];
}

const WantToKnowMore: React.FC<WantToKnowMoreProps> = ({ links }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!links || links.length === 0) {
    return null;
  }

  return (
    <div className="mb-8 border border-site-blue-dark rounded-lg overflow-hidden">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between  bg-white hover:bg-gray-50 transition-colors"
      >
        <div className="text-left">
          <h2 className="text-2xl font-semibold text-site-blue-dark mb-1">
            Want to know more?
          </h2>
          <p className="text-sm text-site-blue-dark">
            Expand this section to view more evidence-based resources.
          </p>
        </div>
        {/* center icon within the circle */}
        <div className="bg-[#e3eaf3] rounded-full p-1 flex-shrink-0 flex items-center justify-center">
          {isExpanded ? (
            // make the icon thicker
            <IoIosArrowUp
              style={{ strokeWidth: "6px" }}
              size={32}
              className="text-site-blue-dark "
            />
          ) : (
            <IoIosArrowDown
              style={{ strokeWidth: "6px" }}
              size={32}
              className="text-site-blue-dark "
            />
          )}
        </div>
      </button>

      {isExpanded && (
        <div className="pt-4 ">
          <div className="space-y-3">
            {links.map((link, index) => (
              <div key={index} className="flex items-start gap-2">
                <FaLink
                  size={18}
                  className="mt-1 text-site-blue-dark flex-shrink-0"
                />
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-site-blue-dark text-sm text-left underline hover:text-site-blue-dark/80 break-words"
                >
                  {link.title}
                </a>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default WantToKnowMore;
